import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserLoginService } from './routes/user-login/user-login.service';
import { SystemVariablesService } from './modules/settings/super-admin/services/system-variables.service';
import { ContactTypesService } from './modules/settings/other/services/contact-types.service';

/**
_______________________________________________________________________________
Root component of the GTLC CMS application. Serves as the application shell
and handles initial bootstrapping logic including authentication checks and
preloading of global data.
_______________________________________________________________________________
*/
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'gtlc';

  constructor(
    private router: Router,
    private loginService: UserLoginService,
    private systemVariablesService: SystemVariablesService,
    private contactTypesService: ContactTypesService,
  ) {}

  /**
  _______________________________________________________________________________
  Initializes the component on startup. Checks authentication state and preloads
  global data including system variables and contact types. Redirects to the
  general dashboard after a 1-second delay if user is not logged in.
  _______________________________________________________________________________
  */
  ngOnInit() {
    const isLoggedIn = this.loginService.isLoggedIn();

    this.systemVariablesService.getAllSystemVariables();
    this.contactTypesService.getAllContactTypes();

    if (!isLoggedIn) {
      setTimeout(() => {
        this.router.navigate(['dashboard', 'general']);
      }, 1000);
    }
  }
}
